"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _index = require("../../../theming/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var WidowFix = function WidowFix(_ref) {
  var children = _ref.children,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? 7 : _ref$threshold;
  return _react["default"].Children.map(children, function (child, i) {
    if (typeof child === "string") {
      var wordArray = child.split(/\s/);
      var firstPart = wordArray.slice(0, -2).join(" ") + " ";
      var lastWord = wordArray.slice(-1)[0];
      var twoLastWords = wordArray.slice(-2).join(" ");
      return _react["default"].createElement(_react["default"].Fragment, null, lastWord.length < threshold ? _react["default"].createElement(_react["default"].Fragment, null, firstPart, _react["default"].createElement(NoBreak, null, twoLastWords)) : _react["default"].createElement(_react["default"].Fragment, null, child));
    } else {
      console.warn("Children must be a string.");
    }
  });
};

var NoBreak = _styledComponents["default"].span.withConfig({
  displayName: "WidowFix__NoBreak",
  componentId: "oyetu8-0"
})(["display:inline-block;backgroun-color:red;"]);

WidowFix.defaultProps = {
  threshold: 7
};
WidowFix.propTypes = {
  children: _index.commonPropTypes.children.isRequired,
  threshold: _propTypes["default"].number
};
var _default = WidowFix;
exports["default"] = _default;